
import React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import getAttributeValueAsText from '../getAttributeValueAsText';

import ObjectDetailAttributeGeneric from './ObjectDetailAttributeGeneric';

const ObjectDetailAttributeLink = ({attribute, dataModel, value}) => {

    const classNames = mergeStyleSets({
        value: {
            width: 150,
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        }
    });

    const processedValue = getAttributeValueAsText(attribute, value);
    const target = attribute.visualize.target || 'app_ext_link';
    const text = attribute.visualize.text || processedValue;

    return (
        <ObjectDetailAttributeGeneric
            attribute={attribute}
            dataModel={dataModel}
            value={value}
            valueComponent={
                <Stack className={classNames.value} title={processedValue}>
                    <Link href={processedValue} target={target}>{text}</Link>
                </Stack>
            }
        />
    );
}

export default ObjectDetailAttributeLink;
